export const MIN_STRING_LENGTH = 1;
export const MAX_FULL_NAME = 100;
export const ORDER_MIN = 0;
export const CONTENT_ORDER_MIN = 1;
export const NAME_PATTERN = /^[a-zA-Z0-9@!#$^%&*()+=\-_[\]\\‘';,./{}|“"`:<>?\s]+$/